module.exports = __webpack_public_path__ + "static/media/signature-no-BG.e5e677de.png";